import { ref, Ref, watch } from 'vue'
import { deleteQueryParam, setQueryParam } from '@app/utils/url-helpers'

export default function useUrlStorage<T>(
  key: string,
  initialValue: T,
  serialize: (value: T) => string
): Ref<T> {
  const value = ref<T>(initialValue) as Ref<T>

  watch(
    value,
    (newValue) => {
      const serialized = serialize(newValue)
      if (serialized !== '') {
        setQueryParam(key, serialized, { replace: true })
      } else {
        deleteQueryParam(key, { replace: true })
      }
    },
    { deep: true }
  )

  return value
}
